import React from 'react';
import Radio from '@material-ui/core/Radio';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Theme from '../../Theme';

const styles = {
  root: {
    '&$checked': {
      color: Theme.colors.weployAqua,
    },
  },
  checked: {},
};

const RadioButton = ({
  onChange,
  value,
  name,
  checked,
  ...rest
}) => (
  <Radio
    checked={checked}
    onChange={onChange}
    value={value}
    name={name}
    {...rest}
  />
);

RadioButton.propTypes = {
  checked: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

export default withStyles(styles)(RadioButton);
